<!-- STATISTICS -->
<div class="row">
    <div class="col-12 col-md-6">
        <div class="row">
            <div class="col-12 col-md-6">
                <app-statistica [icon]="'icon-users'" [iconType]="'feather'" [data]="{label: 'players', value: 128}"></app-statistica>
            </div>
            <div class="col-12 col-md-6">
                <app-statistica [icon]="'experiences.svg'" [iconType]="'custom'" [data]="{label: 'Experience create', value: experiences.length}"></app-statistica>
            </div>
            <div class="col-12 col-md-6">
                <app-statistica [icon]="'interactions.svg'" [iconType]="'custom'" [data]="{label: 'Interactions completate', value: 128}"></app-statistica>
            </div>
            <div class="col-12 col-md-6">
                <app-statistica [icon]="'interactions.svg'" [iconType]="'custom'" [data]="{label: 'Interactions', value: interactions.length}"></app-statistica>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-4">
        <app-statistica [data]="{label: 'Top 4 interactions', itemsList: [{title: 'item1'}, {title: 'item2'}, {title: 'item2'}, {title: 'item2'}, {title: 'item2'}, {title: 'item2'}]}"></app-statistica>
    </div>
    <div class="col-12 col-md-2">
        <div class="row bg-white">
            <div class="col-12 bg-primary text-white p-4">ICX ACTIVATED</div>
            <div class="col-12 p-2">
                <p>
                    Il tuo abbonamento è attivo e sarà disponibile fino al giorno:<br>
                    <b>{{moment(instance.expireDate).format('DD.MM.YYYY')}}</b>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <!-- experiences -->
    <div class="col-6">
        <app-card [hidHeader]="true" [contentType]="'experiences'">
            <span class="h5 font-size-lighter">Experiences</span>
            <div class="row mt-3" *ngIf="experiences.length">
                <div class="col-12 col-md-6" *ngFor="let exp of experiences">
                    <div class="card mb-3" [routerLink]="['/experiences', exp.id]">
                        <div class="image-wrapper" [style.backgroundImage]="'url(' + environment.imageCDN + environment.imageFolder + '/' + exp.image +')'"></div>
                        <div class="card-body">
                            <h5 class="card-title">{{exp.title}}</h5>
                            <p class="card-text">{{ exp.description.length > 100 ? (exp.description | slice:0:100) + '..' : exp.description}}</p>
                            <small class="btn btn-outline-primary btn-sm" [routerLink]="['/experiences', exp.id]">Modifica</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" *ngIf="!experiences.length">
                <div class="col-12">
                    Non hai ancora creato nessuna Esperience.&nbsp;<a href="/experiences/new">Crea la tua prima Experience.</a>
                </div>
            </div>
        </app-card>
    </div>
    <div class="col-12 col-md-4">
        <app-card [hidHeader]="true" [contentType]="'interactions'">
            <span class="h5 font-size-lighter">Interactions</span>
            <div class="row mt-3" *ngIf="interactions.length">
                <div class="col-12">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" *ngFor="let interaction of interactions">
                            <app-interaction-list-item [interaction]="interaction" [routerLink]="['/interactions', interaction.id]"></app-interaction-list-item>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row mt-3" *ngIf="!experiences.length">
                <div class="col-12">
                    Non hai ancora creato nessuna Interaction.&nbsp;<a href="/interactions/new">Crea la tua prima Interaction.</a>
                </div>
            </div>
        </app-card>
    </div>
    <div class="col-12 col-md-2">
        <app-card [hidHeader]="true" [contentType]="'prizes'">
            <span class="h5 font-size-lighter">Prizes</span>
            <div class="row mt-3" *ngIf="prizes.length">
                <div class="col-12">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" *ngFor="let prize of prizes">
                            {{prize.title}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row mt-3" *ngIf="!prizes.length">
                <div class="col-12">
                    Non hai ancora creato nessun Prize.&nbsp;<a href="/prizes/new">Crea il tuo primo Prize.</a>
                </div>
            </div>
        </app-card>
    </div>
</div>